import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'yesNoFormatter',
     
})
export class YesNoPipe implements PipeTransform {
  transform(value: boolean, showNullAsNo: boolean = false) {
    if ((value === null || value === undefined) && !showNullAsNo) {
      return '';
    }

    return value ? 'Yes' : 'No';
  }
}
